module.exports = __webpack_public_path__ + "img/drama.051010b2.svg";